import { connect } from 'react-redux'
import {
  setMobileFilterButtonState,
  setAnalyticsButtonState,
  setMobileSchoolFilterState,
} from 'Modules/searchPage/actions'
import { clearSelectedMarker } from 'Modules/searchMap/actions'
import { docksideOpenSelector } from 'Modules/app/selectors'
import { getLocationSearchObj } from 'Modules/location/selectors'

import MobileContainer from './MobileContainer'

const mapStateToProps = (state) => ({
  analyticsButtonActive: state.searchPage.analyticsButtonActive,
  filterButtonActive: state.searchPage.filterButtonActive,
  isDiscoveryAreaOpen: state.searchPage.isDiscoveryAreaOpen,
  showSaveSearch: state.searchPage.showSaveSearch,
  dockIsOpen: docksideOpenSelector(state),
  filterLookup: state.searchFilters.filterLookup,
  isSchoolFilterOpen: state.searchPage.isSchoolFilterOpen,
  searchObj: getLocationSearchObj(state),
  lastSearchObj: getLocationSearchObj(state),
  isMobileApp: state.app.isMobileApp,
})

const actions = {
  setMobileFilterButtonState,
  setAnalyticsButtonState,
  clearSelectedMarker,
  setMobileSchoolFilterState,
}

export default connect(mapStateToProps, actions)(MobileContainer)
